import { z } from 'zod';
const BaseMapOptionsValidationSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    zoom: z.number(),
    bearing: z.number(),
    pitch: z.number()
});
const MapOptionsValidationSchema = BaseMapOptionsValidationSchema;
const MapOptionsUpdateValidationSchema = BaseMapOptionsValidationSchema;
export { MapOptionsUpdateValidationSchema, MapOptionsValidationSchema };
//# sourceMappingURL=mapOptions.js.map